import React, { useEffect } from 'react';
import { Pagination } from 'react-bootstrap';

const GridPagination = ({ page, pageSize, totalItems, onChange }) => {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const start = totalItems === 0 ? 0 : ((page - 1) * pageSize) + 1;
  const end = Math.min(page * pageSize, totalItems);

  useEffect(() => {
    if (page > totalPages) onChange(totalPages);
  }, [page, totalPages, onChange]);

  if (totalItems <= pageSize) return null;

  const goTo = nextPage => {
    const normalized = Math.min(Math.max(nextPage, 1), totalPages);
    if (normalized !== page) onChange(normalized);
  };

  return (
    <div className="hpj-grid-pagination">
      <span>{start}-{end} de {totalItems}</span>
      <Pagination size="sm" className="mb-0">
        <Pagination.First disabled={page === 1} onClick={() => goTo(1)} />
        <Pagination.Prev disabled={page === 1} onClick={() => goTo(page - 1)} />
        <Pagination.Item active>{page} / {totalPages}</Pagination.Item>
        <Pagination.Next disabled={page === totalPages} onClick={() => goTo(page + 1)} />
        <Pagination.Last disabled={page === totalPages} onClick={() => goTo(totalPages)} />
      </Pagination>
    </div>
  );
};

export default GridPagination;
